// IRAN
export const locale = {
  TRANSLATOR: {
    SELECT: "زبان خود را انتخاب کنید"
  },
  MENU: {
    NEW: "جدید",
    ACTIONS: "عملیات‌ها"
  },
  AUTH: {
    GENERAL: {
      OR: "یا",
      SUBMIT_BUTTON: "تایید",
      NO_ACCOUNT: "اکانت ندارم",
      SIGNUP_BUTTON: "ثبت نام",
      FORGOT_BUTTON: "فراموشی گذرواژه",
      BACK_BUTTON: "برگشت",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "ورود",
      BUTTON: "ورود"
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUCCESS: "Your account has been successfully reset."
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUCCESS: "Your account has been successfuly registered."
    },
    INPUT: {
      EMAIL: "Email",
      FULLNAME: "Fullname",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Username"
    },
    VALIDATION: {
      INVALID: "{{name}} is not valid",
      REQUIRED: "{{name}} is required",
      MIN_LENGTH: "{{name}} minimum length is {{min}}",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "Field is not valid"
    }
  }
};
